<template>
  <div class="componentWrapper" @click="listenOut">

    <div id="services" :class="'grid grid__item_span-12 p0 m0 project-white'">

      <!-- add the project header -->
        <div id="projHeader" class="projheader grid grid__item_span-12 p0 m0">

          <a id="backHome" href="/">
            <span id="image"><img src="../../static/left-arrow.svg" alt="head back to the homepage" title="head back to the homepage" /></span>
            <h4 class="txtWhite uppercase">Go to home</h4>
          </a>

          <div class="image"><img src="../assets/images/Sheep-Animation-page.gif" alt="BSD covid-19 packages" title="BSD covid-19 packages"/></div>
          <div id="text" class="overlay">
            <h2 class="txtWhite">...and this little sheep stayed home.</h2>
            <p class="txtWhite lead">Kia Kaha New Zealand.</p>
            <p class="txtWhite">A big shout out to all of us for doing an incredible job since March, especially the essential workers that have kept the country ticking over.</p>
            <p class="txtWhite">Now more than ever we need to find ways to support each other. Which is why we’ve simplified what we do. You’ve got enough what if’s on your plate as it is, so here’s a way to make your marketing, branding or online services as easy as possible - without going through a  cookie cutter approach.</p>
            <p class="txtWhite">We’ve designed these packages to keep you up and running and help you adapt to the new kind of ‘normal’. Doing the right thing is our mantra, so everything is still designed specifically for you with Blacksheepdesign flair.</p>
          </div>

          <div id="gotoPackages">
            <p>OUR PACKAGES</p><br/>
            <p id="getonlineBtn" @click="gotoPackage('getonline')">Get me online</p><br/>
            <p id="getnoticedBtn" @click="gotoPackage('getnoticed')">I want to be noticed</p><br/>
            <p id="getbrandingBtn" @click="gotoPackage('brandme')">Brand me</p>
          </div>
        </div>

      <!-- Project Content Wrapper  -->
      <div id="packagesContent" class="grid grid__item_span-12 p0 m0">
        <!-- Package one -->
        <div id="getonline" class="package grid grid__item_span-12 p0 m0">
          <div class="text  grid grid__item_span-12 p0 m0">
            <div class="grid__item_span-6 grid m0 p0 hello">
              <h2 class="uppercase">Get me online</h2>
            </div>
            <div class="grid__item_span-6 grid m0 p0 hello">
              <p class="">This is all about getting your business online and social. It is not about getting a template website and squeezing your business into it. We’ll look at your objectives and design a landing page website to fit your brand. It will be backed up by updating (or creating) your social presence through Facebook, Instagram, LinkedIn.</p>
              <a href="/wp-content/themes/wp-bsd/static/img/BSD-Package-Get-Me-Online.pdf" target="_blank"><p>Learn more</p></a>
            </div>
          </div>
          <div class="img grid grid__item_span-12 p0 m0">
            <div class="doubleImage grid grid__item_span-12 p0 m0">
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/get-me-online-hth.jpg" alt="BSD | Hard to Kill | Get me online" title="BSD | Hard to Kill | Get me online" />
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/get-me-online-palmybid.jpg" alt="BSD | Palmy BID | Get me online" title="BSD | Palmy BID | Get me online" />
            </div>
          </div>
        </div>
        <!-- Package two -->
        <div id="getnoticed" class="package grid grid__item_span-12 p0 m0">
          <div class="text  grid grid__item_span-12 p0 m0">
            <div class="grid__item_span-6 grid m0 p0 hello">
              <h2 class="uppercase">I want to be noticed</h2>
            </div>
            <div class="grid__item_span-6 grid m0 p0 hello">
              <p class="">Let’s get you noticed by the type of people who become customers through Google searches and display adverts across the internet. Once we understand your business, we’ll provide a customised advertising solution across one or more of Google Search & Display, Facebook & Instagram, and LinkedIn. Everything is bespoke designed and written, aimed at reaching the right people at the right time with the right message.</p>
              <a href="/wp-content/themes/wp-bsd/static/img/BSD-Package-I-Want-To-Be-Noticed.pdf" target="_blank"><p>Learn more</p></a>
            </div>
          </div>
          <div class="img grid grid__item_span-12 p0 m0">
            <div class="doubleImage grid grid__item_span-12 p0 m0">
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/get-me-noticed-cslaw.jpg" alt="BSD | CS LAW | Get me noticed" title="BSD | CS LAW | Get me noticed" />
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/get-me-noticed-vanillapod.jpg" alt="BSD | Vanilla Pod | Get me noticed" title="BSD | Vanilla Pod | Get me noticed" />
            </div>
          </div>
        </div>
        <!-- Package threee -->
        <div id="brandme" class="package grid grid__item_span-12 p0 m0">
          <div class="text  grid grid__item_span-12 p0 m0">
            <div class="grid__item_span-6 grid m0 p0 hello">
              <h2 class="uppercase">Brand me</h2>
            </div>
            <div class="grid__item_span-6 grid m0 p0 hello">
              <p class="">This package is about who you are and what you stand for.  We’ll take you through our bespoke, tried and tested process, to deliver a logo and a brand that will make sure that the way you visually communicate reflects the excellence that you provide for your customers.</p>
              <a href="/wp-content/themes/wp-bsd/static/img/BSD-Package-Brand-Me.pdf" target="_blank"><p>Learn more</p></a>
            </div>
          </div>
          <div class="img grid grid__item_span-12 p0 m0">
            <div class="doubleImage grid grid__item_span-12 p0 m0">
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/brand-me-velocity50.jpg" alt="BSD | Velocity-50 | Brand Me" title="BSD | Velocity-50 | Brand Me"/>
              <img id="" class="grid__item_span-7 p0 m0" src="../../static/img/brand-me-downtown.jpg" alt="BSD | Downtown Palmerston NOrth | Brand Me" title="BSD | Downtown Palmerston NOrth | Brand Me"/>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div id="footer-sec" class="grid grid__item_span-12 p0 m0" style="margin-top: -1px; position: relative;">
      <div id="serviceFooter" class="grid grid__item_span-12 p0 m0 clear">
        <div class="inner grid grid__item_span-12 clear">

          <a id="back" href="/"><span id="image"><img src="../../static/left-arrow.svg" alt="Go back to the homeepage" title="Go back to the homeepage" /></span><span class="message txtWhite uppercase grid grid__item_span-12 clear m0 p0">Go to home</span></a>

          <div id="contactsec" class="grid grid__item_span-12 m0 p0">
            <div class="txtWhite grid grid__item_span-4 m0 p0">
              <h2 class="txtWhite uppercase">Know exactly what you want to collaborate on?</h2>
               <p class="txtWhite">Let's chat.</p>
            </div>
            <div class="details grid grid__item_span-4 m0 p0 txtWhite">
              <h3 itemprop="telephone"><a href="tel:06 3531983">+64 6 353 1983</a></h3>
              <h3 itemprop="email"><a href="mailto:info@bsd.nz">info@bsd.nz</a></h3>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>

<script>

import menuTransitions from '../assets/js/menu.js'
import animateScrollTo from 'animated-scroll-to'
// import Axios from 'axios'

export default {
  name: 'Service',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      logoColour: 'black',
      metaTitle: '',
      metaDescription: '',
      page: {},
      siblings: [],
      nav: [],
      nextPageLink: '',
      projectType: ''
    }
  },
  metaInfo () {
    return {
      title: 'Kia Kaha NZ',
      meta: [
        { name: 'description', content: 'Helping transition your business from response to recovery and beyond. Marketing, Web and Design to keep you running while adapting to the changing normal.’.' }
      ]
    }
  },
  computed: {
    findLogoColour: function () {
      // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    }
  },
  methods: {
    scrollTo (destination) { // scroll to a div position
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    gotoPackage (item) {
      var section = item
      console.log(section)
      setTimeout(function () {
        var destinationWrap = document.getElementById(section)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    },
    nextPage () {
      // this.navigationDirection = 'forward'
      // console.log(this.nav)
      // console.log(this.$route.params.slug)
      var navLength = this.nav.length - 1
      var currentSlug = this.$route.params.slug
      var nextPage = ''
      var currentPage = this.nav.indexOf(currentSlug)
      if (currentPage === navLength) {
        nextPage = this.nav[0]
      } else {
        nextPage = this.nav[currentPage + 1]
      }
      // console.log(nextPage)
      this.nextPageLink = nextPage
      // if (nextPage) { this.$router.push(nextPage) }
    }
    /* scroller () {
      var d = document.documentElement
      var offset = d.scrollTop + window.innerHeight
      var height = d.offsetHeight - 0.5
      var footerTop = document.getElementById('casestudyFooter').offsetTop - 1
      console.log(footerTop)
      console.log(offset + ', ' + height)
      // if (offset === height || offset >= height) {
      if (footerTop === offset || offset >= footerTop) {
        console.log('at the bottom')
        // this.nextPage()
        // document.getElementById('casestudyFooter').style.position = 'fixed'
        // document.getElementById('casestudyFooter').classList.add('openUp')
      } if (offset <= footerTop) {
        // document.getElementById('casestudyFooter').style.position = 'absolute'
        // document.getElementById('casestudyFooter').classList.remove('openUp')
      }
    } */
  },
  mounted () {
    // Hide the bsdText div until we scroll
    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    setTimeout(function () {
      if (document.getElementById('contactClick')) {
        document.getElementById('contactClick').addEventListener('click', function () {
          setTimeout(function () {
            var destinationWrap = document.getElementById('footer-sec')
            const options = {
              speed: 1900
            }
            animateScrollTo(destinationWrap, options)
          }, 200)
        })
      }
    }, 500)
  },
  created () {
    // this.getData()
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .componentWrapper{
    /* padding: 15vh 0; */
    /* background: #EFF0F1; */
  }

</style>



// WEBPACK FOOTER //
// src/components/packages.vue